/**
 *
 * @module createAccountResult
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class CreateAccountResult
 *
 */
export default class CreateAccountResult {

    /**
     *
     * @param {String} accountId
     * @throws {InvalidArgumentException}
     *
     */
    constructor(accountId) {

        const errorMessage = {
            ctor: 'CreateAccountResult(accountId)',
            get accountId() {
                return `${this.ctor} accountId should be a String with length`;
            }
        };

        nonEmptyString(accountId, errorMessage.accountId, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.accountId = accountId;

    }

}



// WEBPACK FOOTER //
// ./src/services/account/createAccountResult.js